import type {
  CartAdd as CartAddType,
  CartError as CartErrorType,
  Cart as CartType,
  CartUpdate as CartUpdateType,
} from '@grafikr/shopify-typescript/type/endpoints/Cart';

import Queue from 'utils/queue';

export default new (class Cart {
  private queue: Queue;

  constructor() {
    this.queue = new Queue();
  }

  private sendRequest(input: RequestInfo | URL, init?: RequestInit) {
    return this.queue.add(() =>
      fetch(input, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        ...init,
      }),
    );
  }

  private static async handleResponse<T>(response: Response) {
    const body = await response.json();

    return {
      data: response.ok ? (body as T) : undefined,
      error: !response.ok ? (body as CartErrorType) : undefined,
    };
  }

  async add(data: FormData) {
    const response = await this.sendRequest(`${theme.endpoints.cartAdd}.js`, {
      method: 'post',
      body: data,
    });

    return Cart.handleResponse<CartAddType>(response);
  }

  async get() {
    const response = await this.sendRequest(`${theme.endpoints.cart}.js`);

    return Cart.handleResponse<CartType>(response);
  }

  async update(data: FormData) {
    const response = await this.sendRequest(`${theme.endpoints.cartUpdate}.js`, {
      method: 'post',
      body: data,
    });

    return Cart.handleResponse<CartUpdateType>(response);
  }

  async change(data: FormData) {
    const response = await this.sendRequest(`${theme.endpoints.cartChange}.js`, {
      method: 'post',
      body: data,
    });

    return Cart.handleResponse<CartUpdateType>(response);
  }

  async clear() {
    const response = await this.sendRequest(theme.endpoints.cartClear, {
      method: 'post',
    });

    return Cart.handleResponse<CartType>(response);
  }
})();

export const getCart = async () => (await fetch(`${theme.endpoints.cart}.js`)).json();

export const removeItem = async (key: string) => {
  const data = new FormData();
  data.append('id', key);
  data.append('quantity', '0');

  return (
    await fetch(`${theme.endpoints.cartChange}.js`, {
      method: 'post',
      body: data,
    })
  ).json();
};
